// Function to trim the message to the first sentence
export function trimMessageToMaxLength(message: string, maxChars: number) {
  if (!message) {
    return "";
  }
  if (message?.length <= maxChars) {
    return message; // Return the message as is if it's shorter than the max length
  } else {
    // If the message is longer, trim it to the maxChars - 3 (to accommodate the ellipsis) and add '...'
    return message.substring(0, maxChars - 3) + "...";
  }
}
